// extracted by mini-css-extract-plugin
export default {"module":"radio_module__TP86h"};